import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Scheduler, EditIcon, DialogCampusSingleEditVenue, DialogCampusSingleDeleteVenue, DataTable } from "../../../../";
import { Grid, Button, ButtonGroup, Typography, makeStyles, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
var useStyles = makeStyles(function (theme) {
  return {
    resourceContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      marginTop: "-10px"
    },
    resourceName: {
      marginBottom: "0 !important",
      flex: "1 0 0",
      paddingLeft: "4px"
    },
    editIcon: {
      color: "#ffe082",
      marginLeft: "8px",
      cursor: "pointer"
    },
    deleteIcon: {
      cursor: "pointer"
    }
  };
});

var CampusSingleTabVenues = function CampusSingleTabVenues(props) {
  var classes = useStyles();

  var _useState = useState("venues"),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogEditVenue = _useState4[0],
      setOpenDialogEditVenue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDialogDeleteVenue = _useState6[0],
      setOpenDialogDeleteVenue = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedVenue = _useState8[0],
      setSelectedVenue = _useState8[1];

  var handleModalDialogEditVenue = function handleModalDialogEditVenue() {
    setOpenDialogEditVenue(!openDialogEditVenue);
  };

  var handleModalDialogDeleteVenue = function handleModalDialogDeleteVenue() {
    setOpenDialogDeleteVenue(!openDialogDeleteVenue);
  };

  var handleButtonResource = function handleButtonResource(resource, action) {
    setSelectedVenue(resource);

    switch (action) {
      case "delete":
        handleModalDialogDeleteVenue();
        break;

      case "edit":
        handleModalDialogEditVenue();
        break;

      default:
        break;
    }
  };

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DialogCampusSingleEditVenue, {
    open: openDialogEditVenue,
    onClose: handleModalDialogEditVenue,
    data: selectedVenue,
    onSubmit: props.handleEditVenue,
    translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.edit_venue || null : null : null
  }), /*#__PURE__*/React.createElement(DialogCampusSingleDeleteVenue, {
    open: openDialogDeleteVenue,
    onClose: handleModalDialogDeleteVenue,
    data: selectedVenue,
    onSubmit: props.handleDeleteVenue,
    translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_venue || null : null : null
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: false,
    md: 8
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4,
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    color: "primary",
    "aria-label": "outlined primary button group"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: type === "venues" ? "contained" : "outlined",
    onClick: function onClick() {
      setType("venues");
    }
  }, props.translation ? props.translation.buttons ? props.translation.buttons.per_venues || "Per venues" : "Per venues" : "Per venues"), /*#__PURE__*/React.createElement(Button, {
    variant: type === "groups" ? "contained" : "outlined",
    onClick: function onClick() {
      setType("groups");
    }
  }, props.translation ? props.translation.buttons ? props.translation.buttons.per_groups || "Per groups" : "Per groups" : "Per groups"), /*#__PURE__*/React.createElement(Button, {
    variant: type === "list" ? "contained" : "outlined",
    onClick: function onClick() {
      setType("list");
    }
  }, props.translation ? props.translation.buttons ? props.translation.buttons.list || "List" : "List" : "List")))), type === "venues" || type === "groups" ? /*#__PURE__*/React.createElement(Scheduler, {
    ownLogicDayStart: true,
    ownLogicDayEnd: true,
    canChangeResourceName: true,
    events: type === "venues" ? props.activitiesPerVenue.activities : type === "groups" ? props.activitiesPerGroup.activities : [],
    resources: type === "venues" ? props.activitiesPerVenue.venues.map(function (venue) {
      return _objectSpread(_objectSpread({}, venue), {}, {
        name: /*#__PURE__*/React.createElement("div", {
          className: classes.resourceContainer
        }, /*#__PURE__*/React.createElement(Tooltip, {
          title: venue.name
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.resourceName
        }, venue.name.length > 12 ? venue.name.substring(0, 10) + "..." : venue.name)), /*#__PURE__*/React.createElement(EditIcon, {
          className: classes.editIcon,
          onClick: function onClick() {
            return handleButtonResource(venue, "edit");
          }
        }), /*#__PURE__*/React.createElement(DeleteIcon, {
          className: classes.deleteIcon,
          color: "secondary",
          onClick: function onClick() {
            return handleButtonResource(venue, "delete");
          }
        }))
      });
    }) : type === "groups" ? props.activitiesPerGroup.groups : [],
    canAddResource: type === "venues",
    handleSubmitModalAddResource: props.handleSubmitModalAddResource,
    translation: props.translation ? _objectSpread(_objectSpread({}, props.translation), {}, {
      scheduler: _objectSpread(_objectSpread({}, props.translation.scheduler), {}, {
        resourceName: type === "venues" ? props.translation.scheduler.resourceVenueName : type === "groups" ? props.translation.scheduler.resourceGroupName : ""
      })
    }) : null
  }) : type === "list" ? /*#__PURE__*/React.createElement(DataTable, {
    translation: props.translation ? props.translation.datatables ? props.translation.datatables.venues : null : null,
    options: {
      selectableRows: false
    },
    data: props.activitiesPerVenue.venues.map(function (venue) {
      return {
        id: venue.id,
        name: venue.name
      };
    })
  }) : null);
};

export { CampusSingleTabVenues };